import loadable from '@nordvpn/teams.core/lib/tools/loadable';
export var OrganizationMonetizationSettings = loadable(function () {
    return import(/* webpackPrefetch: true */ './pages/OrganizationMonetizationSettings');
});
